<script>
export default {
  props: ["clr"],
};
</script>
<template>
  <svg
    width="95"
    height="94"
    viewBox="0 0 95 94"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M43.4573 2.75419C45.9799 1.3903 49.0201 1.39029 51.5427 2.75419L67.9299 11.6144L83.7967 21.376C86.2391 22.8787 87.7592 25.5116 87.8393 28.3782L88.3598 47L87.8393 65.6218C87.7592 68.4884 86.2391 71.1213 83.7967 72.624L67.9299 82.3856L51.5427 91.2458C49.0201 92.6097 45.9799 92.6097 43.4573 91.2458L27.0701 82.3856L11.2033 72.624C8.7609 71.1213 7.24078 68.4884 7.16066 65.6218L6.64019 47L7.16066 28.3782C7.24078 25.5116 8.76089 22.8787 11.2033 21.376L27.0701 11.6144L43.4573 2.75419Z"
      stroke="#F2F2F0"
    />
    <mask id="path-2-inside-1_3263_1621" fill="white">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M51.2208 15.8768L73.095 28.5059C74.0955 29.0821 74.9265 29.9117 75.5042 30.9113C76.0819 31.9109 76.386 33.0451 76.3857 34.1997V59.4643C76.3861 60.6177 76.0827 61.7508 75.5062 62.7497C74.9296 63.7487 74.1002 64.5782 73.1014 65.1548L51.2272 77.784C50.2286 78.3605 49.0959 78.664 47.9429 78.664C46.7898 78.664 45.6571 78.3605 44.6585 77.784L22.7843 65.1548C21.7855 64.5782 20.9561 63.7487 20.3796 62.7497C19.803 61.7508 19.4997 60.6177 19.5 59.4643V34.1997C19.4997 33.0463 19.803 31.9132 20.3796 30.9143C20.9561 29.9153 21.7855 29.0858 22.7843 28.5091L44.6585 15.88C45.6571 15.3035 46.7898 15 47.9429 15C49.0959 15 50.2286 15.3035 51.2272 15.88L51.2208 15.8768Z"
      />
    </mask>
    <path
      d="M51.2208 15.8768L51.6676 14.9822L50.7208 16.7428L51.2208 15.8768ZM73.095 28.5059L72.595 29.372L72.5959 29.3725L73.095 28.5059ZM76.3857 34.1997L75.3857 34.1994V34.1997H76.3857ZM76.3857 59.4643H75.3857V59.4646L76.3857 59.4643ZM73.1014 65.1548L72.6014 64.2888L73.1014 65.1548ZM51.2272 77.784L51.7272 78.65V78.65L51.2272 77.784ZM44.6585 77.784L44.1585 78.65V78.65L44.6585 77.784ZM22.7843 65.1548L23.2843 64.2888H23.2843L22.7843 65.1548ZM19.5 59.4643L20.5 59.4646V59.4643H19.5ZM19.5 34.1997H20.5L20.5 34.1994L19.5 34.1997ZM22.7843 28.5091L23.2843 29.3752L23.2843 29.3752L22.7843 28.5091ZM44.6585 15.88L44.1585 15.014V15.014L44.6585 15.88ZM51.2272 15.88L50.7803 16.7746L51.7272 15.014L51.2272 15.88ZM50.7208 16.7428L72.595 29.372L73.595 27.6399L51.7208 15.0108L50.7208 16.7428ZM72.5959 29.3725C73.4441 29.861 74.1486 30.5643 74.6384 31.4117L76.37 30.4109C75.7043 29.2592 74.7468 28.3032 73.594 27.6393L72.5959 29.3725ZM74.6384 31.4117C75.1282 32.2591 75.3859 33.2207 75.3857 34.1994L77.3857 34.1999C77.386 32.8696 77.0357 31.5627 76.37 30.4109L74.6384 31.4117ZM75.3857 34.1997V59.4643H77.3857V34.1997H75.3857ZM75.3857 59.4646C75.386 60.4424 75.1288 61.403 74.6401 62.2499L76.3723 63.2496C77.0366 62.0986 77.3861 60.793 77.3857 59.4641L75.3857 59.4646ZM74.6401 62.2499C74.1513 63.0967 73.4482 63.7999 72.6014 64.2888L73.6014 66.0209C74.7523 65.3564 75.7079 64.4006 76.3723 63.2496L74.6401 62.2499ZM72.6014 64.2888L50.7272 76.9179L51.7272 78.65L73.6014 66.0209L72.6014 64.2888ZM50.7272 76.9179C49.8807 77.4067 48.9204 77.664 47.9429 77.664V79.664C49.2715 79.664 50.5766 79.3143 51.7272 78.65L50.7272 76.9179ZM47.9429 77.664C46.9654 77.664 46.0051 77.4067 45.1585 76.9179L44.1585 78.65C45.3091 79.3143 46.6143 79.664 47.9429 79.664V77.664ZM45.1585 76.9179L23.2843 64.2888L22.2843 66.0209L44.1585 78.65L45.1585 76.9179ZM23.2843 64.2888C22.4376 63.7999 21.7344 63.0967 21.2457 62.2499L19.5135 63.2496C20.1778 64.4006 21.1334 65.3564 22.2843 66.0209L23.2843 64.2888ZM21.2457 62.2499C20.7569 61.403 20.4997 60.4424 20.5 59.4646L18.5 59.4641C18.4996 60.793 18.8492 62.0986 19.5135 63.2496L21.2457 62.2499ZM20.5 59.4643V34.1997H18.5V59.4643H20.5ZM20.5 34.1994C20.4997 33.2216 20.7569 32.261 21.2457 31.4141L19.5135 30.4144C18.8492 31.5654 18.4996 32.871 18.5 34.1999L20.5 34.1994ZM21.2457 31.4141C21.7344 30.5673 22.4376 29.8641 23.2843 29.3752L22.2843 27.6431C21.1334 28.3076 20.1778 29.2634 19.5135 30.4144L21.2457 31.4141ZM23.2843 29.3752L45.1585 16.7461L44.1585 15.014L22.2843 27.6431L23.2843 29.3752ZM45.1585 16.7461C46.0051 16.2573 46.9654 16 47.9429 16V14C46.6143 14 45.3091 14.3497 44.1585 15.014L45.1585 16.7461ZM47.9429 16C48.9204 16 49.8807 16.2573 50.7272 16.7461L51.7272 15.014C50.5766 14.3497 49.2714 14 47.9429 14V16ZM51.6741 14.9854L51.6676 14.9822L50.7739 16.7714L50.7803 16.7746L51.6741 14.9854Z"
      fill="#F18F01"
      mask="url(#path-2-inside-1_3263_1621)"
    />
    <path
      d="M59.5032 60.2474L56.1123 56.8564"
      stroke="#F18F01"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M38.887 56.8564L35.4961 60.2474"
      stroke="#F18F01"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M42.9057 37.4131C47.3903 35.5548 52.5528 36.581 55.9858 40.0132C59.4187 43.4455 60.446 48.6077 58.5887 53.0927C56.7313 57.5778 52.3551 60.5025 47.5007 60.5025C42.6463 60.5025 38.2697 57.5787 36.4119 53.0938C33.8754 46.9705 36.7827 39.9503 42.9057 37.4131"
      stroke="#F18F01"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M40.7477 33.7017C39.0284 33.1958 37.1698 33.5983 35.8138 34.7702C34.4578 35.942 33.7901 37.7226 34.0414 39.4971"
      stroke="#F18F01"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M54.251 33.7017C55.9702 33.1965 57.8284 33.5993 59.1842 34.771C60.54 35.9426 61.2078 37.7227 60.9573 39.4971"
      stroke="#F18F01"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M47.4993 48.1186V44.2568"
      stroke="#F18F01"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M47.6907 52.553C47.6907 52.6304 47.6441 52.7002 47.5726 52.7298C47.5011 52.7594 47.4188 52.7431 47.364 52.6883C47.3093 52.6336 47.293 52.5513 47.3226 52.4798C47.3522 52.4083 47.422 52.3617 47.4993 52.3617"
      stroke="#F18F01"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M47.4994 52.3617C47.605 52.3617 47.6907 52.4473 47.6907 52.553"
      stroke="#F18F01"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
